import script from "./ProjectsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsList.vue?vue&type=style&index=0&id=c386d0c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c386d0c4"]])

export default __exports__